export default __webpack_public_path__ + "static/media/bg.be3c7663.png";